import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import AnnouncementStats from "../model/AnnouncementStats";

export const AnnouncementStatsApiService = async (request: number): Promise<AnnouncementStats> => {
  const url = `/announcements/${request}/detailedstats/`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAnnouncementStatsApiService = (id: number) =>
  useQuery<Promise<AnnouncementStats>, AxiosError, AnnouncementStats>(
    [ "AnnouncementStatsApiService", id], () =>
      AnnouncementStatsApiService(id)
  );

export default useAnnouncementStatsApiService;